import _ from 'lodash';
import {User} from "../services/user/user";
export class CommonHelpers {
//  sort array in A to Z
  static sortAtoZ(arrayList: any) {
    return arrayList.sort((a, b) => a.scac > b.scac ? 1 : -1);
  }

  //  sort array in A to Z, then year and then qtr
  static sortAtoZByYearByQtr(arrayList: any) {
    return arrayList.sort((a, b) => {
      if (a.scac < b.scac)  return -1;
      if (a.scac > b.scac)  return 1;

      if (a.reportingYear > b.reportingYear) return -1;
      if (a.reportingYear < b.reportingYear) return 1;

      return parseInt(b.reportingQuarter) - parseInt(a.reportingQuarter);
    });
  }

  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  static checkUserRoles(currentUser: User | any, roles?) {
    if (currentUser) {
      const userRoles = _.map(currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }
}
